export enum DefaultParamSource {
  URL = 'URL',
  SESSION_STORAGE = 'SESSION_STORAGE',
  API = 'API',
}
